import React from 'react'
import i18next from 'i18next'
import {Button, Tooltip} from 'antd'
import { DownloadOutlined } from '@ant-design/icons'
import {fetchInvoice} from '@/stores/invoices/services/fetchers'
import {hasPermissions} from '@/stores/auth/services'
import {PermissionsMap} from '@/stores/auth/constants/permissions-map'
import { DOWNLOAD_INVOICE } from '@/constants/playwright-ids'

const columns = () => [
    {
        key: 'period',
        dataIndex: 'period',
        title: i18next.t('Invoices.period')
    },
    {
        key: 'date',
        dataIndex: 'date',
        title: i18next.t('Invoices.date')
    },
    {
        key: 'id',
        dataIndex: 'id',
        title: i18next.t('Invoices.id')
    },
    {
        key: 'amount',
        dataIndex: 'amount',
        title: i18next.t('Invoices.amount')
    },
    {
        key: 'currency',
        dataIndex: 'currency',
        title: i18next.t('Invoices.currency')
    }
]

export const getColumns = () => {
    return hasPermissions([PermissionsMap.invoices.full]) ? (
        [
            ...columns(),
            {
                key: 'action',
                title: i18next.t('Invoices.action'),
                render: (item) => (
                    <Tooltip title={i18next.t('Invoices.download')}>
                        <Button
                            type={'link'}
                            onClick={() => fetchInvoice(item.id, `${item.id}.pdf`)}
                            size={'small'}
                            icon={<DownloadOutlined />}
                            data-test-id={DOWNLOAD_INVOICE}
                        />
                    </Tooltip>
                )
            }
        ]
    ) : columns()
}
